<template>
  <v-row class="pt-5" v-if="items">
    <v-col cols="10" offset="1">
      <v-row>
         <v-col cols="6">
          <p class="green--text headline mt-10">Do</p>
          <ul class="list--none">
            <li
              class="ma-1"
              v-for="(tag, index) in results.do"
              :key="index"
            >
              <span class="pr-2">{{ tag.title|sentence }}</span>
            </li>
          </ul>
        </v-col>
        <v-col cols="6">
          <p class="blue--text headline mt-10">Feel</p>
          <ul class="list--none">
            <li class="ma-1" v-for="(tag, index) in results.feel" :key="index">
              <span class="pr-2">{{ tag.title|sentence }}</span>
            </li>
          </ul>
        </v-col>
       
        <v-col cols="6">
          <p class="deep-orange--text headline mt-10">Say</p>
          <ul class="list--none">
            <li
              class="ma-1"
              v-for="(tag, index) in results.say"
              :key="index"
            >
              <span class="pr-2">{{ tag.title|sentence }}</span>
            </li>
          </ul>
        </v-col>
         <v-col cols="6">
          <p class="pink--text headline mt-10">Think</p>
          <ul class="list--none">
            <li
              class="ma-1"
              v-for="(tag, index) in results.think"
              :key="index"
            >
              <span class="pr-2">{{ tag.title|sentence }}</span>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsEmpathyUser",
  data() {
    return {
      items: null,
      admins: null,
      results: {
        do:[],
        feel:[],
        say:[],
        think:[],
      }
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      this.doc = null;
      let ref = fb.empathyExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.forEach((doc) => {
            let post = doc.data();
            console.log(post);
            this.getResults(post.doc)
          });
          if (items) {
            this.items = items;
          }
        })
        .catch(function() {});
    },
    getResults(doc) {
      this.pushToArray(doc.do, 'do')
      this.pushToArray(doc.feel, 'feel')
      this.pushToArray(doc.say, 'say')
      this.pushToArray(doc.think, 'think')
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        console.log(arr);
         arr.forEach((y) => {
          this.results[model].push(y)
        });
      }
    }
  },
};
</script>
